var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0796 0.4375C6.5874 0.4375 0.51709 6.50781 0.51709 14C0.51709 21.4922 6.5874 27.5625 14.0796 27.5625C21.5718 27.5625 27.6421 21.4922 27.6421 14C27.6421 6.50781 21.5718 0.4375 14.0796 0.4375ZM20.7405 9.72891L18.5147 20.218C18.3507 20.9617 17.9077 21.1422 17.2897 20.7922L13.8991 18.293L12.264 19.868C12.0835 20.0484 11.9304 20.2016 11.5804 20.2016L11.821 16.7508L18.1046 11.0742C18.378 10.8336 18.0444 10.6969 17.6835 10.9375L9.91787 15.8266L6.571 14.782C5.84365 14.5523 5.82725 14.0547 6.72412 13.7047L19.7999 8.6625C20.4069 8.44375 20.9374 8.81016 20.7405 9.72891Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.125,
    height: 28,
    fill: "white",
    transform: "translate(0.51709)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.4c8a53898464cb7a44b9b9773999f72c.svg";
export { ForwardRef as ReactComponent };